export const typeErrors = [
    {
        statusCode: 'DEFAULT',
        messageTranslated: 'Error, por favor comunicar al administrador del sistema.',
    },
    {
        statusCode: 'INTERNAL_SERVER_ERROR',
        messageTranslated: 'Error inesperado, consulte al administrador del sistema.',
    },
    { statusCode: 'NOT_FOUND', messageTranslated: 'Recurso no encontrado.' },
    { statusCode: 'USER_NOT_FOUND', messageTranslated: 'Usuario no encontrado.' },
    { statusCode: 'auth/wrong-password', messageTranslated: 'Contraseña incorrecta, verifique y vuelva a intentar.' },
    {
        statusCode: 'auth/too-many-requests',
        messageTranslated:
            'El acceso a está cuenta ha sido deshabilitado temporalmente debido a continuos intentos fallidos. Puede habilitarse inmediatamente restaurando su contraseña o puede intentarlo de nuevo más tarde.',
    },
    {
        statusCode: 'auth/user-not-found',
        messageTranslated: 'El email no ha sido registrado como usuario, verifique y vuelva a intentar.',
    },
    {
        statusCode: 'NotAuthorizedException',
        messageTranslated: 'Nombre de usuario o contraseña incorrecta, vuelva a intentar.',
    },
    {
        statusCode: 'NotAuthorizedExceptionConfirmed',
        messageTranslated: 'No se puede confirmar al usuario. El estado actual es CONFIRMADO.',
    },
    {
        statusCode: 'NotAuthorizedExceptionForgot',
        messageTranslated: 'La contraseña de usuario no se puede restablecer en el estado actual.',
    },
    {
        statusCode: 'UsernameExistsException',
        messageTranslated: 'Ya existe una cuenta con el correo electrónico proporcionado.',
    },
    {
        statusCode: 'UserNotFoundException',
        messageTranslated: 'El usuario no existe.',
    },
    {
        statusCode: 'CodeMismatchException',
        messageTranslated: 'Se proporcionó un código de verificación no válido. Vuelva a intentarlo.',
    },
    {
        statusCode: 'LimitExceededException',
        messageTranslated: 'Se superó el límite de intentos, inténtelo después de un tiempo.',
    },
    {
        statusCode: 'UNAUTHORIZED_USER',
        messageTranslated: 'Usuario No autorizado, debe ser un usuario tipo Cliente o Administrador.',
    },
    {
        statusCode: 'InvalidParameterException',
        messageTranslated: 'No se puede restablecer la contraseña del usuario vuelva a intantarlo',
    },
    {
        statusCode: 'ExpiredCodeException',
        messageTranslated:
            'No se puede restablecer la contraseña del usuario con este Codigo, esta Vencido o ya fue usado Vuelva a solicitar que olvido la contraseña',
    },
    {
        statusCode: 'UserNotConfirmedException',
        messageTranslated:
            'Aún no has verificado tu correo. Te enviamos un nuevo correo con un código de verificación.',
    },
];
